module.exports = __webpack_public_path__ + "media/images/cog-transparent-abffab39b2ee845ce670d211d05ee8e8.svg";